import React, {useEffect, useState} from 'react';
import Modal from 'react-bootstrap/Modal';
import {MapSettingsColorBlock} from "../../AdminComponents/map-settings/MapSettingsColorBlock";
import {ColorRange} from "../../../services/network/form30ColorSettings-api";
import styles from "../../AdminComponents/map-settings/MapSettingsColorModal.module.css";
import {useSaveForm30ColorSettings} from "../../../hooks/useQuery/useSaveForm30ColorSettings";
import classNames from 'classnames';

interface Form30ColorModalProps {
    show?: boolean;
    onHide?: () => void;
    year: number;
    table_id: string;
    row_id: string;
    column_key: string;
    initialColors: ColorRange[];
}

export const Form30ColorModal: React.FC<Form30ColorModalProps> = ({
    show = false,
    onHide = () => {},
    year,
    table_id,
    row_id,
    column_key,
    initialColors
}) => {
    const [colors, setColors] = useState<ColorRange[]>([]);
    const [isColorPickerVisible, setIsColorPickerVisible] = useState(false);
    const { saveColorSettings } = useSaveForm30ColorSettings();

    useEffect(() => {
        if (initialColors?.length) {
            setColors(initialColors);
        }
    }, [initialColors]);

    const handleUpdateColors = (updatedColors: ColorRange[]) => {
        saveColorSettings({
            year,
            table_id,
            row_id,
            column_key,
            colors: updatedColors
        });
        onHide();
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            contentClassName={classNames(styles.modalContent, {
                [styles.hidden]: isColorPickerVisible
            })}
        >
            <Modal.Header closeButton className={styles.modalHeader}>
                <Modal.Title id="contained-modal-title-vcenter">
                    Настройка цветов показателей
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className={styles.modalBody}>
               <MapSettingsColorBlock
                   colors={colors}
                   onSave={handleUpdateColors}
                   onColorPickerVisibilityChange={setIsColorPickerVisible}
               />
            </Modal.Body>
        </Modal>
    );
};
